import {SET_BUSINESS, SET_BUSINESSES} from "../../constants/businessConstants";

const initialState = {
    business: null,
    businesses: [],
    filteredBusinesses: [],
};

const businessReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BUSINESS:
            if (action.business === null) {
                return {...state, business: null}
            } else {
                return {
                    ...state,
                    business: {...state.business, ...action.business},
                };
            }
        case SET_BUSINESSES:
            return {
                ...state,
                businesses: action.filtered ? state.businesses : action.businesses,
                filteredBusinesses: action.filtered ? action.businesses : state.filteredBusinesses,
            };
        default:
            return state;
    }
};

export default businessReducer;
